export default __webpack_public_path__ + "static/media/EasterDay_08.ef284e0f.png";